import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'

/** Stable destination keys for settings pages opened as workspace tabs. */
export const WORKSPACE_SETTINGS_DESTINATION = {
  appConfig: 'Org & Site App Config',
  manageUsers: 'Manage Users',
  managePermissions: 'Manage Permissions',
  manageAccess: 'Manage Access',
  healthCheck: 'Health Check',
  manageExtensions: 'Manage Extensions',
  costDashboard: 'Cost Dashboard',
  uploadDocs: 'Upload Documents',
  evaluations: 'Evaluations',
} as const

/** `path` plus the org/site query the settings pages expect. */
export function orgSiteHref(
  path: string,
  organizationId: string | undefined,
  siteId: string | undefined
): string {
  const params = new URLSearchParams()
  if (organizationId) params.set(SEARCH_PARAM_ORG_ID, organizationId)
  if (siteId) params.set(SEARCH_PARAM_SITE_ID, siteId)
  const query = params.toString()
  return query ? `${path}?${query}` : path
}

export function evaluationsHref({
  organizationId,
  siteId,
}: {
  organizationId?: string
  siteId?: string
}): string {
  return orgSiteHref('/evaluations', organizationId, siteId)
}
